'use strict';

bbw.model.Photo = ngtk.model.Item.extend({

    getId: function() {
        return this._data.id;
    },

    canSetMain: function() {
        return this.getId() && this._data.album_type == 'public' && this._data.is_moderated;
    },

    setMain: function() {
        if (!this.getId()) {
            throw new Error("Photo ID is undefined");
        }
        if (this._data.album_type != 'public') {
            throw new Error("Cannot setMain() a non-public photo");
        }
        if (!this._data.is_moderated) {
            throw new Error("Cannot setMain() an unmoderated photo");
        }
        if (this._data.is_main) {
            return this.$q.when(true);
        }
        return this._loadFromApi('post', 'user/photos/set-main', {photo_id: this.getId()}).then(function() {
            this._data.is_main = true;
        }.bind(this));
    },

    setModeratorApproved: function() {
        if (!this.getId()) {
            throw new Error("Photo ID is undefined");
        }
        if (this._data.album_type != 'public') {
            throw new Error("Cannot approve a non-public photo");
        }
        return this._loadFromApi('post', 'user/photos/approve', {
            photo_id: this.getId(), user_id: this.get('user_id')
        }).then(function() {
            this._data.is_moderated = true;
        }.bind(this));
    },

    setIntimate: function(isIntimate) {
        if (!this.getId()) {
            throw new Error("Photo ID is undefined");
        }
        isIntimate = !!isIntimate;
        if (this._data.is_private) {
            throw new Error("Cannot setIntimate() a private photo");
        }
        return this._loadFromApi('post', 'user/photos/set-intimate', {
            photo_id: this.getId(), user_id: this.get('user_id'), is_intimate: isIntimate
        }).then(function() {
            this._data.is_intimate = isIntimate;
        }.bind(this));
    },

    isChecked: function() {
        return this._data.is_checked;
    },

    check: function() {
        this._data.is_checked = true;
    },

    uncheck: function() {
        delete this._data.is_checked;
    },

    toggleChecked: function() {
        this.isChecked() ? this.uncheck() : this.check();
    },

    _extractIdFromItemData: function(itemData) {
        return itemData.id;
    }

});